import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-list-more-popover',
  templateUrl: './list-more-popover.component.html',
  styleUrls: ['./list-more-popover.component.scss'],
})
export class ListMorePopoverComponent implements OnInit {

  @Input() list: IListPopover[] = [];

  constructor(
    private popoverCtrl: PopoverController
  ) { }

  ngOnInit() {}

  public onSelect = async ({ id }) => await this.popoverCtrl.dismiss({ id });

}

interface IListPopover { id: number | string; name: string; icon?: string };